import * as React from 'react';

var _path, _g;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgCodex = function SvgCodex(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "blockchain_codex",
        width: 120,
        height: 120,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M120 60c0-33.137-26.863-60-60-60S0 26.863 0 60s26.863 60 60 60 60-26.863 60-60"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#blockchain_codex)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#181818",
        d: "M120 60c0-33.137-26.863-60-60-60S0 26.863 0 60s26.863 60 60 60 60-26.863 60-60"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M27.806 36.194h-5v47.612h5zm27.25 47.612C41.91 83.806 31.25 73.148 31.25 60S41.91 36.194 55.056 36.194zM102.67 60c0 13.148-10.659 23.806-23.806 23.806S55.057 73.148 55.057 60s10.658-23.806 23.806-23.806c13.147 0 23.806 10.658 23.806 23.806",
        clipRule: "evenodd"
    }))));
};

export { SvgCodex as ReactComponent };
//# sourceMappingURL=Codex.svg.es.js.map
